import type { SearchSuggestFieldProps } from '~/components/SearchSuggest/types';

/**
 * Opções de campo dropdown quando o **pai** controla o rótulo da seleção
 * (`searchTerm` vindo de URL/store): não limpar o input ao escolher sugestão e
 * formato de exibição região com vírgula.
 *
 * **SRP:** `Suggest.vue` usa `resetSearchTermOnSelect: true` e formato padrão (`' - '`).
 */
export interface SearchSuggestParentDrivenSelectionFieldConfig extends Pick<
	SearchSuggestFieldProps,
	'resetSearchTermOnSelect' | 'regionSelectTextFormat'
> {}

export function useSearchSuggestParentDrivenSelectionFieldConfig(): SearchSuggestParentDrivenSelectionFieldConfig {
	return {
		resetSearchTermOnSelect: false,
		regionSelectTextFormat: 'region-comma'
	};
}
